import { Component, OnInit } from '@angular/core'
import { UsersService } from '../../services/users.service'
import { StartupService } from '../../services/startup.service'

@Component({
  selector: 'ld-app',
  template: require('./app.component.html'),
  styles: [require('./app.component.css')]
})
export class AppComponent implements OnInit {
  constructor (
    private usersService: UsersService,
    private startupService: StartupService) {
  }

  ngOnInit () {
    this.usersService.currentUser.cast(this.startupService.userData)
  }
}



// WEBPACK FOOTER //
// ../~/angular2-template-loader!./app/components/app/app.component.ts